<template>
  <div>

    <v-container fluid class="pa-md-8 pt-md-2">
      <v-row>
        <v-col>
          <ul class="text-caption">
            <li>Bestanden in de lokaal opgeslagen registraties blijven 31 dagen bewaard.</li>
            <li>Cloud opgeslagen registraties ouder dan één jaar worden automatisch verwijderd.</li>
          </ul>
        </v-col>
      </v-row>
    </v-container>

    <registration-outbox-list @registration-sent="fetchNewSavedRegistrations"></registration-outbox-list>

    <saved-registration-list ref="saved-registration-list"></saved-registration-list>

  </div>
</template>

<script>
import RegistrationOutboxList from "@/views/forms/RegistrationOutboxList.vue";
import SavedRegistrationList from "@/views/forms/SavedRegistrationList.vue";

export default {
  name: "UnsendRegistrationList",
  components: {SavedRegistrationList, RegistrationOutboxList},
  methods: {
    fetchNewSavedRegistrations() {
      // Trigger method in 'saved-registration-list' component
      this.$refs['saved-registration-list'].reloadSavedRegistrations()
    },
  },
}
</script>

<style scoped>

</style>